import React, { useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import ActionTable from "../../components/table/ActionTable";
import BookmarkRemoveIcon from "@mui/icons-material/BookmarkRemove";
import IconButton from "@mui/material/IconButton";
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";

let _listaSalvas = [];

export default function Home({ history }) {
  const [listaRotasSalvas, setListaRotasSalvas] = useState(
    JSON.parse(localStorage.getItem("painel_admin_menus_salvos"))
      ? JSON.parse(localStorage.getItem("painel_admin_menus_salvos"))
      : []
  );
  const [listaRotasRecentes, setListaRotasRecentes] = useState(
    JSON.parse(localStorage.getItem("painel_admin_menus_recentes"))
      ? JSON.parse(localStorage.getItem("painel_admin_menus_recentes"))
      : []
  );

  useEffect(() => {
    carregar();
  }, []);

  const carregar = () => {
    const listaSalvos = [...listaRotasSalvas];
    const listaRecentes = [...listaRotasRecentes];

    if (listaSalvos) {
      listaSalvos.forEach((item) => {
        item.exibir = (
          <p
            onClick={() => history.push(`/app/${item.rota}`)}
            style={{ cursor: "pointer" }}
          >
            <b>{item.nome}</b> ({item.grupoNome} {">"} {item.menuPaiNome} {">"}{" "}
            {item.nome} )
          </p>
        );

        item.acao = (
          <Tooltip title="Remover da lista de páginas salvas">
            <IconButton onClick={() => remover(item)}>
              <BookmarkRemoveIcon />
            </IconButton>
          </Tooltip>
        );
      });
      setListaRotasSalvas(listaSalvos);
      _listaSalvas = listaSalvos;
    }

    if (listaRecentes) {
      listaRecentes.forEach((item) => {
        item.exibir = (
          <p
            onClick={() => history.push(`/app/${item.rota}`)}
            style={{ cursor: "pointer" }}
          >
            <b>{item.nome}</b> ({item.grupoNome} {">"} {item.menuPaiNome} {">"}{" "}
            {item.nome} )
          </p>
        );
        item.acao = (
          <Tooltip title="Salvar página">
            <IconButton onClick={() => adicionar(item)}>
              <BookmarkAddedIcon />
            </IconButton>
          </Tooltip>
        );
      });
      setListaRotasRecentes(listaRecentes);
    }
  };

  const adicionar = (item) => {
    let novoItem = { ...item };
    const listaAtualizada = [..._listaSalvas];
    const listaStorage = [];
    if (_listaSalvas.find((m) => m.id === item.id)) return;

    novoItem.exibir = (
      <p
        onClick={() => history.push(`/app/${item.rota}`)}
        style={{ cursor: "pointer" }}
      >
        <b>{item.nome}</b> ({item.grupoNome} {">"} {item.menuPaiNome} {">"}{" "}
        {item.nome} )
      </p>
    );
    novoItem.acao = (
      <Tooltip title="Remover da lista de páginas salvas">
        <IconButton onClick={() => remover(item)}>
          <BookmarkRemoveIcon />
        </IconButton>
      </Tooltip>
    );

    listaAtualizada.push(novoItem);

    listaAtualizada.forEach((l) => {
      listaStorage.push({
        id: l.id,
        nome: l.nome,
        rota: l.rota,
        grupoNome: l.grupoNome,
        menuPaiNome: l.menuPaiNome,
      });
    });

    localStorage.setItem(
      "painel_admin_menus_salvos",
      JSON.stringify(listaStorage)
    );

    setListaRotasSalvas(listaAtualizada);
    _listaSalvas = listaAtualizada;
  };

  const remover = (item) => {
    if (_listaSalvas.length === 1) {
      localStorage.setItem("painel_admin_menus_salvos", JSON.stringify([]));
      setListaRotasSalvas([]);
      _listaSalvas = [];
      return;
    }

    const listaAtualizada = _listaSalvas.filter((m) => m.id !== item.id);

    const listaStorage = [];

    listaAtualizada.forEach((l) => {
      listaStorage.push({
        id: l.id,
        nome: l.nome,
        rota: l.rota,
        grupoNome: l.grupoNome,
        menuPaiNome: l.menuPaiNome,
      });
    });

    localStorage.setItem(
      "painel_admin_menus_salvos",
      JSON.stringify(listaStorage)
    );
    _listaSalvas = listaAtualizada;
    setListaRotasSalvas(listaAtualizada);
  };

  const tRegistrosRecentes = {
    title: "Páginas recentes",
    columns: [
      {
        label: "Página",
        name: "exibir",
      },
      {
        label: "Salvar",
        name: "acao",
      },
    ],
    array: listaRotasRecentes,
  };

  const tRegistrosSalvos = {
    title: "Páginas salvas",
    columns: [
      {
        label: "Página",
        name: "exibir",
      },
      {
        label: "Remover",
        name: "acao",
      },
    ],
    array: listaRotasSalvas,
  };

  return (
    <>
      {listaRotasSalvas.length > 0 && (
        <ActionTable structure={tRegistrosSalvos} />
      )}
      <ActionTable structure={tRegistrosRecentes} />
    </>
  );
}
